import { Injectable } from '@angular/core';
import {
    Chatbot,
    createChatbot,
    trackChabotButtonClickSpec,
    trackChabotFormCompleteSpec,
    trackChabotStartDiscussionSpec,
    trackChabotTriggerSpec,
    trackChabotUserTriggerSpec,
} from '@urweb/snowtype';

/* eslint-disable @typescript-eslint/no-explicit-any */

@Injectable({
    providedIn: 'root',
})
export class LeadooService {
    private _customEvents: { [key: string]: { name: string; fn: (obj: any) => void } } = {
        'TRIGGER': { name: 'trigger', fn: trackChabotTriggerSpec },
        'USER TRIGGER': { name: 'user_trigger', fn: trackChabotUserTriggerSpec },
        'DISCUSSION': { name: 'start_discussion', fn: trackChabotStartDiscussionSpec },
        'LEAD': { name: 'form_complete', fn: trackChabotFormCompleteSpec },
        'GTM': { name: 'button_click', fn: trackChabotButtonClickSpec },
    };

    private dispatchDataLayerPushEvents() {
        const dataLayer: any = window.dataLayer || [];
        const originalPush = dataLayer.push.bind(dataLayer);

        dataLayer.push = function (obj: unknown) {
            originalPush(obj);
            window.dispatchEvent(new CustomEvent('dataLayer.push', { detail: obj }));
        };
    }

    private addDataLayerEventTrigger(event_name: string, callback: (obj: any) => void) {
        if (typeof event_name !== 'string' || typeof callback !== 'function') {
            console.error('Invalid arguments provided for addDataLayerEventTrigger');
            return;
        }

        window.addEventListener('dataLayer.push', (event) => {
            const customEvent = event as CustomEvent;

            if (customEvent.detail && customEvent.detail.event === event_name) {
                callback(customEvent.detail);
            }
        });
    }

    enableTracking(): void {
        this.dispatchDataLayerPushEvents();

        Object.keys(this._customEvents).forEach((x) => {
            this.addDataLayerEventTrigger(x, (e) => {
                const chatbot: Chatbot = {
                    bot_name: e.bot_name,
                    bot_nickname: e.bot_nickname,
                    bot_category: e.bot_category,
                    bot_type: e.category,
                };
                const event = {
                    event_type: this._customEvents[x].name,
                    label: e.label ? [e.label] : null,
                    message_text: e.text ? e.text : null,
                    context: [createChatbot(chatbot)],
                };

                this._customEvents[x].fn(event);
            });
        });
    }
}
